import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useState, useEffect, Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { SpatialThree } from './SpatialThree.js';
import { loadXRModule } from './xr/xrModule.js';
// Lazy-load XR components. If @react-three/xr is not installed,
// the dynamic imports fail and the catch provides fallbacks.
const LazyXRWrapper = React.lazy(
// eslint-disable-next-line implicit-arrow-linebreak, function-paren-newline
() => import('./xr/XRWrapper.js').catch(() => ({
    default: ({ children }) => children,
})));
const LazyXREnterButton = React.lazy(
// eslint-disable-next-line implicit-arrow-linebreak, function-paren-newline
() => import('./xr/XREnterButton.js').catch(() => ({
    default: () => null,
})));
export const SpatialWrapper = forwardRef((props, canvasRef) => {
    const [xrAvailable, setXrAvailable] = useState(false);
    useEffect(() => {
        loadXRModule()
            .then(() => setXrAvailable(true))
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => { });
    }, []);
    return (_jsxs("div", { style: { width: '100%', height: '100%' }, children: [xrAvailable && (_jsx(Suspense, { fallback: null, children: _jsx(LazyXREnterButton, {}) })), _jsx(Canvas, { style: { position: 'absolute', top: 0, left: 0 }, camera: {
                    fov: 50,
                    up: [0, 1, 0],
                    position: [0, 0, 800],
                    near: 0.1,
                    far: 3000,
                }, gl: { antialias: true, logarithmicDepthBuffer: false }, ref: canvasRef, children: xrAvailable ? (_jsx(Suspense, { fallback: _jsx(SpatialThree, { ...props }), children: _jsx(LazyXRWrapper, { children: _jsx(SpatialThree, { ...props, xrEnabled: true }) }) })) : (_jsx(SpatialThree, { ...props })) })] }));
});
//# sourceMappingURL=SpatialWrapper.js.map